import { render } from "./PageWrapper.vue?vue&type=template&id=4dac9c22&scoped=true"
import script from "./PageWrapper.vue?vue&type=script&lang=ts"
export * from "./PageWrapper.vue?vue&type=script&lang=ts"

import "./PageWrapper.vue?vue&type=style&index=0&id=4dac9c22&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4dac9c22"

export default script